import React from 'react'
import Icon from './Icon'

const Delete = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="M21,17.5 L21,24.5 C21,24.776 21.224,25 21.5,25 C21.776,25 22,24.776 22,24.5 L22,17.5 C22,17.224 21.776,17 21.5,17 C21.224,17 21,17.224 21,17.5 Z M24,26.5 C24,26.776 23.776,27 23.5,27 L16.5,27 C16.224,27 16,26.776 16,26.5 L16,15 L17.5,15 L22.5,15 L24,15 L24,26.5 Z M18,13.5 C18,13.224 18.224,13 18.5,13 L21.5,13 C21.776,13 22,13.224 22,13.5 L22,14 L18,14 L18,13.5 Z M24.5,14 L23,14 L23,13.5 C23,12.673 22.327,12 21.5,12 L18.5,12 C17.673,12 17,12.673 17,13.5 L17,14 L15.5,14 L13.5,14 C13.224,14 13,14.224 13,14.5 C13,14.776 13.224,15 13.5,15 L15,15 L15,26.5 C15,27.327 15.673,28 16.5,28 L23.5,28 C24.327,28 25,27.327 25,26.5 L25,15 L26.5,15 C26.776,15 27,14.776 27,14.5 C27,14.224 26.776,14 26.5,14 L24.5,14 Z M18,17.5 L18,24.5 C18,24.776 18.224,25 18.5,25 C18.776,25 19,24.776 19,24.5 L19,17.5 C19,17.224 18.776,17 18.5,17 C18.224,17 18,17.224 18,17.5 Z" />
    </g>
  </Icon>
)

export default Delete



// WEBPACK FOOTER //
// ./icons/Delete.js